import  useCarusel from './useCarusel';
export default useCarusel
